import { z } from 'zod';
import { supabase } from '@/utils/supabase';

const preferenceSchema = z.object({
  recipient_email: z.string().min(1),
  paused: z.boolean(),
  updated_at: z.string().nullable()
});
export type DisclosureReminderPreference = z.infer<typeof preferenceSchema>;

export async function getDisclosureReminderPreferences(loanId: string): Promise<DisclosureReminderPreference[]> {
  const { data, error } = await supabase.rpc('get_borrower_disclosure_reminder_preferences', {
    p_encompass_loan_id: loanId
  });
  if (error) {
    throw error;
  }
  return z.array(preferenceSchema).parse(data);
}

export async function setDisclosureReminderPaused(loanId: string, email: string, paused: boolean, expectedUpdatedAt: string | null): Promise<string | null> {
  const { data, error } = await supabase.rpc('set_borrower_disclosure_reminder_paused', {
    p_encompass_loan_id: loanId,
    p_recipient_email: email,
    p_paused: paused,
    p_expected_updated_at: expectedUpdatedAt
  });
  if (error) {
    throw error;
  }
  return z.string().nullable().parse(data);
}
